import { render, staticRenderFns } from "./GemAIBanner.vue?vue&type=template&id=d06f76b6&scoped=true&"
import script from "./GemAIBanner.vue?vue&type=script&lang=js&"
export * from "./GemAIBanner.vue?vue&type=script&lang=js&"
import style0 from "./GemAIBanner.vue?vue&type=style&index=0&id=d06f76b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f76b6",
  null
  
)

export default component.exports